export const KIOSK_THEMES = [
  {
    id: "doenies", name: "Slackr", swatch: ["#FDF6EC", "#7C3AED"],
    vars: { "--k-bg": "linear-gradient(165deg,#FDF6EC 0%,#F3E9F7 100%)", "--k-panel": "#FFFFFF", "--k-text": "#1A1030", "--k-accent": "#7C3AED", "--k-accent-ink": "#FFFFFF", "--k-border": "#1A1030", "--k-shadow": "rgba(26,16,48,0.35)" },
  },
  {
    id: "taupe", name: "Taupe", swatch: ["#EFE7DD", "#A88F6A"],
    vars: { "--k-bg": "linear-gradient(160deg,#F1EAE0 0%,#DDD1C1 100%)", "--k-panel": "#FBF7F1", "--k-text": "#2E2519", "--k-accent": "#A88F6A", "--k-accent-ink": "#FFFFFF", "--k-border": "#2E2519", "--k-shadow": "rgba(46,37,25,0.3)" },
  },
  {
    id: "goud", name: "Goud", swatch: ["#1C1A15", "#D4AF37"],
    vars: { "--k-bg": "linear-gradient(160deg,#241F17 0%,#12100C 100%)", "--k-panel": "#2B271E", "--k-text": "#F5EEDD", "--k-accent": "#D4AF37", "--k-accent-ink": "#1C1A15", "--k-border": "#0B0A07", "--k-shadow": "rgba(0,0,0,0.6)" },
  },
  {
    id: "pastel", name: "Rosé", swatch: ["#FDF2F8", "#C76B96"],
    vars: { "--k-bg": "linear-gradient(160deg,#FDF2F8 0%,#F6E1EC 100%)", "--k-panel": "#FFFFFF", "--k-text": "#4A2540", "--k-accent": "#C76B96", "--k-accent-ink": "#FFFFFF", "--k-border": "#4A2540", "--k-shadow": "rgba(74,37,64,0.3)" },
  },
  {
    id: "nacht", name: "Nacht", swatch: ["#14181F", "#7C93FF"],
    vars: { "--k-bg": "linear-gradient(160deg,#1B2130 0%,#0E1218 100%)", "--k-panel": "#20283A", "--k-text": "#EEF2FB", "--k-accent": "#7C93FF", "--k-accent-ink": "#0A0E14", "--k-border": "#0A0E14", "--k-shadow": "rgba(0,0,0,0.6)" },
  },
  {
    id: "salie", name: "Salie", swatch: ["#EAF0E8", "#5E8A6A"],
    vars: { "--k-bg": "linear-gradient(160deg,#ECF1E9 0%,#D8E3D6 100%)", "--k-panel": "#FBFDF9", "--k-text": "#22301F", "--k-accent": "#5E8A6A", "--k-accent-ink": "#FFFFFF", "--k-border": "#22301F", "--k-shadow": "rgba(34,48,31,0.3)" },
  },
];

export const getKioskTheme = (id) => KIOSK_THEMES.find((t) => t.id === id) || KIOSK_THEMES[0];
